(function () {
  'use strict';

  function initMatchQuiz(quiz) {
    var step = quiz.querySelector('[data-bx-match-step]');
    var result = quiz.querySelector('[data-bx-match-result]');
    var resultTitle = quiz.querySelector('[data-bx-result-title]');
    var resultCopy = quiz.querySelector('[data-bx-result-copy]');
    var resultLink = quiz.querySelector('[data-bx-result-link]');
    var progress = quiz.querySelectorAll('[data-bx-progress]');
    var options = quiz.querySelectorAll('input[name="bx-match-goal"]');

    if (!step || !result || !resultTitle || !resultCopy || !resultLink) return;

    var recommendations = {
      effortless: {
        title: 'Start with Ready-to-Wear wigs',
        copy: 'Beginner-friendly styles designed for a natural finish with less installation time.',
        href: '/collections/wigs',
        label: 'Shop Ready-to-Wear'
      },
      volume: {
        title: 'Build your look with Raw Bundles',
        copy: 'Choose your texture and length, then complete the install with a matching closure.',
        href: '/collections/bundles',
        label: 'Shop Raw Bundles'
      },
      custom: {
        title: 'Create a custom wig',
        copy: 'Personalize the cap, closure, length and finish with guidance from B. Xquisit.',
        href: '/products/custom-wig',
        label: 'Build your custom wig'
      },
      care: {
        title: 'Protect your healthy-hair foundation',
        copy: 'Use a salon-tested care routine for your natural hair, wigs and extensions.',
        href: '/collections/hair-care-products',
        label: 'Shop Hair Care'
      }
    };

    options.forEach(function (input) {
      input.addEventListener('change', function () {
        var choice = recommendations[input.value] || recommendations.effortless;

        quiz.querySelectorAll('.bx-match__option').forEach(function (option) {
          option.classList.toggle('is-selected', option.contains(input));
        });

        resultTitle.textContent = choice.title;
        resultCopy.textContent = choice.copy;
        resultLink.textContent = choice.label;
        resultLink.setAttribute('href', choice.href);
        step.hidden = true;
        result.hidden = false;
        progress.forEach(function (bar) { bar.classList.add('is-active'); });
        resultTitle.focus({ preventScroll: true });
        saveMatchPreference(input.value, choice.title);
        track('quiz_answer_selected', {
          quiz_name: 'hair_match',
          answer: input.value,
          recommendation: choice.title,
          destination: choice.href
        });
      });
    });
  }

  function saveMatchPreference(answer, recommendation) {
    try {
      window.localStorage.setItem('bxHairMatch', JSON.stringify({
        answer: answer,
        recommendation: recommendation
      }));
    } catch (error) {
      /* Storage may be unavailable in private browsing; the form still works. */
    }
    updateSignupContext(answer, recommendation);
  }

  function updateSignupContext(answer, recommendation) {
    document.querySelectorAll('.bx-first-order-form').forEach(function (form) {
      var tags = form.querySelector('[data-bx-signup-tags]');
      var note = form.querySelector('[data-bx-signup-note]');
      var matchTag = answer ? 'hair-match-' + answer : '';
      var baseTags = ['newsletter', 'first-order-15', 'website-signup'];
      if (matchTag) baseTags.push(matchTag);
      if (tags) tags.value = baseTags.join(', ');
      if (note) note.value = recommendation ? 'Hair match recommendation: ' + recommendation : 'Website first-order offer signup';
    });
  }

  function restoreMatchPreference() {
    try {
      var stored = JSON.parse(window.localStorage.getItem('bxHairMatch') || 'null');
      if (stored && stored.answer) updateSignupContext(stored.answer, stored.recommendation || '');
    } catch (error) {
      updateSignupContext('', '');
    }
  }

  function analyticsProcessingAllowed() {
    var customerPrivacy = window.Shopify && window.Shopify.customerPrivacy;

    if (!customerPrivacy || typeof customerPrivacy.analyticsProcessingAllowed !== 'function') {
      return true;
    }

    return customerPrivacy.analyticsProcessingAllowed();
  }

  function track(eventName, details) {
    if (!analyticsProcessingAllowed()) return;

    var dataLayerEventName = 'bx_' + eventName;
    var customerEventName = 'bxquisit:' + eventName;
    var eventDetails = Object.assign({
      page_path: window.location.pathname,
      page_title: document.title,
      currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : ''
    }, details || {});

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({
      event: dataLayerEventName
    }, eventDetails));

    if (typeof window.gtag === 'function') {
      window.gtag('event', dataLayerEventName, eventDetails);
    }

    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      try {
        var published = window.Shopify.analytics.publish(customerEventName, eventDetails);
        if (published && typeof published.catch === 'function') published.catch(function () {});
      } catch (error) {
        /* Tracking must never interrupt the shopping experience. */
      }
    }
  }

  function initConversionTracking() {
    if (document.documentElement.dataset.bxTrackingReady === 'true') return;
    document.documentElement.dataset.bxTrackingReady = 'true';

    document.addEventListener('click', function (event) {
      var target = event.target.closest('a, button, .js-grid-cart');
      if (!target) return;

      var href = target.getAttribute('href') || '';
      var card = target.closest('.product-card');
      var productName = card && card.querySelector('.product-card__name');

      if (target.matches('.js-grid-cart, .product-form__cart-submit')) {
        track('add_to_cart_click', {
          variant_id: target.dataset.id || '',
          product_name: productName ? productName.textContent.trim() : ((document.querySelector('.product-single__title') || {}).textContent || '').trim(),
          source: card ? 'product_card' : 'product_page'
        });
      }

      var routineProduct = target.closest('[data-bx-routine-product]');
      if (routineProduct) {
        track('cart_routine_click', {
          product_handle: routineProduct.getAttribute('data-bx-routine-product') || '',
          action: target.matches('.js-grid-cart') ? 'add_to_cart' : 'view_product',
          destination: href
        });
      }

      if (href.indexOf('vagaro.com') !== -1) {
        track('booking_click', { destination: href });
      }

      if (target.matches('.js-cart-btn-checkout, [name="checkout"]') || href === '/checkout') {
        track('checkout_click', { destination: href || '/checkout' });
      }

      if (card && target.closest('a.product-card__image, a.product-card__name')) {
        track('product_click', {
          product_name: productName ? productName.textContent.trim() : '',
          destination: href
        });
      }

      if (target.matches('[data-bx-result-link]')) {
        track('quiz_recommendation_click', {
          recommendation: target.textContent.trim(),
          destination: href
        });
      }

      if (target.matches('[data-bx-offer-link]')) {
        track('first_order_offer_click', { destination: href });
      }

      if (target.matches('[data-bx-save-match]')) {
        track('save_match_click', { destination: href });
      }

      const confidenceLink = target.closest('[data-bx-confidence-link]');
      if (confidenceLink) {
        track('product_confidence_click', {
          link_type: confidenceLink.getAttribute('data-bx-confidence-link'),
          destination: confidenceLink.getAttribute('href') || href,
          product_name: productName ? productName.textContent.trim() : ''
        });
      }

      const footerLink = target.closest('[data-bx-footer-link]');
      if (footerLink) {
        track('footer_navigation_click', {
          link_group: footerLink.getAttribute('data-bx-footer-link'),
          link_text: footerLink.textContent.trim(),
          destination: footerLink.getAttribute('href') || href
        });
      }

      const recoveryLink = target.closest('[data-bx-recovery-link]');
      if (recoveryLink) {
        track('recovery_navigation_click', {
          recovery_path: recoveryLink.getAttribute('data-bx-recovery-link'),
          destination: recoveryLink.getAttribute('href') || href
        });
      }

      const optionsLink = target.closest('.bx-card-options');
      if (optionsLink) {
        track('choose_options_click', {
          product_name: productName ? productName.textContent.trim() : '',
          destination: optionsLink.getAttribute('href') || href,
          source: document.body.classList.contains('template-search') ? 'search' : 'collection'
        });
      }

      if (target.matches('[data-bx-category-link]')) {
        track('category_navigation_click', {
          category: target.textContent.trim(),
          destination: href,
          source: document.body.classList.contains('template-search') ? 'search' : 'collection'
        });
      }

      var recommendedProduct = target.closest('[data-bx-recommended-product]');
      if (recommendedProduct && href) {
        var recommendedName = recommendedProduct.querySelector('.product-card__name');
        track('recommended_product_click', {
          product_name: recommendedName ? recommendedName.textContent.trim() : '',
          destination: href,
          source: 'complete_the_look'
        });
      }

      if (target.closest('.mobile-facets__open-wrapper')) {
        track('collection_filter_opened', {
          source: document.body.classList.contains('template-search') ? 'search' : 'collection'
        });
      }
    });

    document.addEventListener('change', function (event) {
      var field = event.target;
      if (!field) return;

      if (field.matches('select[name="sort_by"]')) {
        track('collection_sort_changed', {
          sort_by: field.value,
          source: document.body.classList.contains('template-search') ? 'search' : 'collection'
        });
      }

      if (field.matches('input[name^="filter."]')) {
        track('collection_filter_changed', {
          filter_name: field.name,
          filter_value: field.value,
          selected: Boolean(field.checked),
          source: document.body.classList.contains('template-search') ? 'search' : 'collection'
        });
      }
    });

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (form && (form.action || '').indexOf('/search') !== -1) {
        var query = form.querySelector('input[name="q"]');
        track('search_submit', {
          query: query ? query.value.trim() : '',
          source: form.closest('.template-search') ? 'search_page' : 'site_search'
        });
      }

      if (form && (form.action || '').indexOf('/contact') !== -1 && form.querySelector('input[type="email"]')) {
        var firstNameInput = form.querySelector('[name="contact[first_name]"]');
        var signupTags = form.querySelector('[data-bx-signup-tags]');
        var match = signupTags ? signupTags.value.match(/hair-match-([a-z-]+)/) : null;
        track('email_signup_submit', {
          form_id: form.id || 'newsletter',
          has_first_name: Boolean(firstNameInput && firstNameInput.value.trim()),
          hair_match: match ? match[1] : ''
        });
      }
    });
  }

  function initProductGallery(gallery) {
    if (!gallery || gallery.dataset.bxGalleryReady === 'true') return;
    gallery.dataset.bxGalleryReady = 'true';

    var main = gallery.querySelector('.my-gallery');
    var current = gallery.querySelector('[data-bx-media-current]');
    var total = Number(gallery.getAttribute('data-bx-media-total')) || 1;
    var lastTrackedIndex = -1;

    function update(index, source) {
      var safeIndex = Math.max(0, Math.min(Number(index) || 0, total - 1));
      if (current) current.textContent = String(safeIndex + 1);
      if (safeIndex === lastTrackedIndex) return;
      lastTrackedIndex = safeIndex;
      track('product_media_view', {
        media_position: safeIndex + 1,
        media_total: total,
        interaction_source: source || 'gallery'
      });
    }

    if (main && window.jQuery) {
      window.jQuery(main).on('afterChange.bxGallery', function (_event, _slick, currentSlide) {
        update(currentSlide, 'swipe_or_arrow');
      });
    }

    gallery.addEventListener('click', function (event) {
      var thumbnail = event.target.closest('.product-single__thumbnail-item');
      if (thumbnail) {
        var thumbnails = Array.prototype.slice.call(gallery.querySelectorAll('.product-single__thumbnail-item'));
        update(thumbnails.indexOf(thumbnail), 'thumbnail');
      }

      if (event.target.closest('.product__photo-wrapper')) {
        track('product_media_zoom', {
          media_position: Number(current ? current.textContent : 1) || 1,
          media_total: total
        });
      }
    });

    update(0, 'initial');
  }

  function initCartAccessibility() {
    var lastCartTrigger = null;

    function updateCartState(cart, trigger) {
      if (!cart) return;
      var isOpen = cart.classList.contains('active');
      var wasOpen = cart.dataset.bxCartWasOpen === 'true';
      var cartToggle = trigger || cart.querySelector('.js-toggle-cart');
      if (cartToggle) cartToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      document.body.classList.toggle('bx-cart-open', isOpen);
      cart.dataset.bxCartWasOpen = isOpen ? 'true' : 'false';

      if (isOpen && !wasOpen) {
        track('cart_drawer_opened', {
          item_count: parseInt(((cart.querySelector('.js-cart-count') || {}).textContent || '0'), 10) || 0
        });
      }

      if (isOpen) {
        var closeButton = cart.querySelector('.mini-cart-header .close');
        if (closeButton) closeButton.focus({ preventScroll: true });
      }
    }

    document.addEventListener('click', function (event) {
      var toggle = event.target.closest('.js-toggle-cart');
      var close = event.target.closest('.overlaycart, .mini-cart-header .close');
      var remove = event.target.closest('.js-remove-mini-cart');
      var quantityButton = event.target.closest('.mini-cart-item .js-qty__adjust');

      if (toggle) {
        lastCartTrigger = toggle;
        window.setTimeout(function () {
          var drawer = toggle.closest('.js-mini-cart');
          updateCartState(drawer, toggle);
        }, 0);
      }

      if (close) {
        var cart = close.closest('.js-mini-cart');
        window.setTimeout(function () {
          updateCartState(cart, lastCartTrigger);
          if (lastCartTrigger) lastCartTrigger.focus({ preventScroll: true });
        }, 0);
      }

      if (remove) {
        track('cart_item_removed', {
          product_name: remove.dataset.productTitle || '',
          variant_id: remove.dataset.id || ''
        });
      }

      if (quantityButton) {
        var item = quantityButton.closest('.mini-cart-item');
        var quantity = item && item.querySelector('.js-qty__input');
        var title = item && item.querySelector('.bx-mini-cart-title');
        window.setTimeout(function () {
          track('cart_quantity_changed', {
            product_name: title ? title.textContent.trim() : '',
            direction: quantityButton.classList.contains('js-qty__plus') ? 'increase' : 'decrease',
            quantity: quantity ? parseInt(quantity.value, 10) || 0 : 0
          });
        }, 0);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var cart = document.querySelector('.js-mini-cart.cardraw.active');
      if (!cart) return;
      cart.classList.remove('active');
      updateCartState(cart, lastCartTrigger);
      if (lastCartTrigger) lastCartTrigger.focus({ preventScroll: true });
    });

    document.querySelectorAll('.js-mini-cart.cardraw').forEach(function (cart) {
      cart.dataset.bxCartWasOpen = cart.classList.contains('active') ? 'true' : 'false';
      new MutationObserver(function () {
        updateCartState(cart, lastCartTrigger);
      }).observe(cart, { attributes: true, attributeFilter: ['class'] });
    });
  }

  function initProductGuidance(section) {
    if (!section || section.dataset.bxProductGuidanceReady === 'true') return;

    var form = section.querySelector('.product-form');
    var summary = section.querySelector('[data-bx-selected-options]');
    var summaryPrice = section.querySelector('[data-bx-variant-price]');
    var availability = section.querySelector('[data-bx-variant-availability]');
    var optionGroups = section.querySelectorAll('[data-bx-option-step]');
    if (!form || !optionGroups.length) return;

    section.dataset.bxProductGuidanceReady = 'true';

    function optionValue(group) {
      var checked = group.querySelector('input[type="radio"]:checked');
      var select = group.querySelector('.single-option-selector');
      return checked ? checked.value : (select ? select.value : '');
    }

    function updateGuidance(trackChange) {
      var values = [];

      optionGroups.forEach(function (group) {
        var value = optionValue(group);
        var current = group.querySelector('[data-bx-option-current]');
        if (value) values.push(value);
        if (current) current.textContent = value;
        group.classList.toggle('is-complete', Boolean(value));
      });

      if (summary) summary.textContent = values.join(' · ');

      var displayedPrice = section.querySelector('.product-single__price:not(.product-single__price--compare)');
      var addButton = section.querySelector('.product-form__cart-submit');
      var isAvailable = addButton ? !addButton.disabled && !addButton.classList.contains('btn--sold-out') : true;
      if (summaryPrice && displayedPrice) summaryPrice.textContent = displayedPrice.textContent.trim();
      if (availability) {
        availability.textContent = isAvailable ? 'Available' : 'Sold out';
        availability.classList.toggle('is-sold-out', !isAvailable);
      }

      if (trackChange) {
        track('product_option_changed', {
          product_name: ((section.querySelector('.product-single__title') || {}).textContent || '').trim(),
          selection: values.join(' / ')
        });
      }
    }

    form.addEventListener('change', function (event) {
      if (event.target.matches('.single-option-selector, .single-option-selector__radio')) {
        window.setTimeout(function () { updateGuidance(true); }, 80);
      }
    });

    updateGuidance(false);
  }

  function initBundleSavings(panel) {
    if (!panel || panel.dataset.bxBundleReady === 'true') return;

    var form = panel.closest('form');
    var section = panel.closest('[data-section-type="product"]');
    var shopifySection = panel.closest('.shopify-section');
    var tiers = panel.querySelectorAll('[data-bx-bundle-tier]');
    var quantityInput = form && form.querySelector('input[name="quantity"]');
    var variantSelect = form && form.querySelector('select[name="id"]');
    var propertyInput = panel.querySelector('[data-bx-bundle-property]');
    var status = panel.querySelector('[data-bx-bundle-status]');
    var productJson = shopifySection && shopifySection.querySelector('script[id^="ProductJson-"]');
    var productData = null;
    var discountRequest = null;

    if (!form || !quantityInput || !variantSelect || !tiers.length || !productJson) return;

    try {
      productData = JSON.parse(productJson.textContent);
    } catch (error) {
      return;
    }

    panel.dataset.bxBundleReady = 'true';

    function selectedVariant() {
      var selectedId = String(variantSelect.value || '');
      return (productData.variants || []).find(function (variant) {
        return String(variant.id) === selectedId;
      }) || productData.variants[0];
    }

    function money(cents) {
      if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
        return theme.Currency.formatMoney(Math.round(cents), theme.moneyFormat);
      }

      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: panel.dataset.bxCurrency || 'USD'
      }).format(cents / 100);
    }

    function updatePrices() {
      var variant = selectedVariant();
      if (!variant) return;

      tiers.forEach(function (tier) {
        var quantity = Number(tier.dataset.quantity) || 1;
        var percent = Number(tier.dataset.discountPercent) || 0;
        var regularTotal = variant.price * quantity;
        var savings = Math.round(regularTotal * percent / 100);
        var offerTotal = regularTotal - savings;
        var price = tier.querySelector('[data-bx-bundle-price]');
        var saving = tier.querySelector('[data-bx-bundle-saving]');

        if (price) price.textContent = money(offerTotal) + ' total';
        if (saving) saving.textContent = 'You save ' + money(savings);
      });
    }

    function applyDiscount(tier) {
      var code = tier.dataset.discountCode || '';
      if (!code || panel.dataset.bxAppliedCode === code) return Promise.resolve();
      if (discountRequest) return discountRequest;

      panel.classList.add('is-applying');
      if (status) status.textContent = 'Applying your bundle savings…';

      discountRequest = fetch('/discount/' + encodeURIComponent(code), {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).then(function (response) {
        if (!response.ok) throw new Error('Discount could not be applied');
        panel.dataset.bxAppliedCode = code;
        if (status) status.textContent = 'Bundle savings applied. Final savings appear at checkout.';
        track('bundle_discount_applied', {
          product_name: panel.dataset.bxProductTitle || '',
          quantity: Number(tier.dataset.quantity) || 1,
          savings_percent: Number(tier.dataset.discountPercent) || 0
        });
      }).catch(function () {
        if (status) status.textContent = 'Your bundle savings will be confirmed at checkout.';
      }).finally(function () {
        panel.classList.remove('is-applying');
        discountRequest = null;
      });

      return discountRequest;
    }

    function selectTier(tier, shouldApply) {
      var quantity = Number(tier.dataset.quantity) || 1;
      var percent = Number(tier.dataset.discountPercent) || 0;

      quantityInput.value = quantity;
      tiers.forEach(function (choice) {
        var selected = choice === tier;
        choice.classList.toggle('is-selected', selected);
        choice.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      if (propertyInput) propertyInput.value = quantity + ' Raw Bundles — save ' + percent + '%';
      if (shouldApply) applyDiscount(tier);

      track('bundle_tier_selected', {
        product_name: panel.dataset.bxProductTitle || '',
        quantity: quantity,
        savings_percent: percent
      });
    }

    tiers.forEach(function (tier) {
      tier.addEventListener('click', function () {
        selectTier(tier, true);
      });
    });

    quantityInput.addEventListener('change', function () {
      var quantity = Number(quantityInput.value) || 1;
      var matchingTier = quantity >= 3 ? tiers[tiers.length - 1] : (quantity === 2 ? tiers[0] : null);

      if (matchingTier) {
        selectTier(matchingTier, true);
      } else {
        tiers.forEach(function (tier) {
          tier.classList.remove('is-selected');
          tier.setAttribute('aria-pressed', 'false');
        });
        if (propertyInput) propertyInput.value = '';
        if (status) status.textContent = 'Select an offer and your savings will appear at checkout.';
      }
    });

    form.addEventListener('change', function (event) {
      if (event.target.matches('.single-option-selector, .single-option-selector__radio, select[name="id"]')) {
        window.setTimeout(updatePrices, 100);
      }
    });

    form.addEventListener('submit', function () {
      var selected = panel.querySelector('[data-bx-bundle-tier].is-selected');
      if (!selected) return;
      track('bundle_add_to_cart', {
        product_name: panel.dataset.bxProductTitle || '',
        quantity: Number(quantityInput.value) || 1,
        savings_percent: Number(selected.dataset.discountPercent) || 0
      });
    });

    updatePrices();
  }

  function initDesktopNavigation() {
    var toggles = document.querySelectorAll('.site-nav [data-bx-menu-toggle]');

    function closeMenus(exceptItem) {
      toggles.forEach(function (toggle) {
        var item = toggle.closest('.site-nav__item');
        if (!item || item === exceptItem) return;
        item.classList.remove('bx-menu-open');
        toggle.setAttribute('aria-expanded', 'false');
      });
    }

    toggles.forEach(function (toggle) {
      var item = toggle.closest('.site-nav__item');

      if (item) {
        item.addEventListener('mouseenter', function () {
          if (!window.matchMedia('(min-width: 992px)').matches) return;
          closeMenus(item);
          item.classList.add('bx-menu-open');
          toggle.setAttribute('aria-expanded', 'true');
        });

        item.addEventListener('mouseleave', function () {
          if (!window.matchMedia('(min-width: 992px)').matches) return;
          item.classList.remove('bx-menu-open');
          toggle.setAttribute('aria-expanded', 'false');
        });
      }

      toggle.addEventListener('click', function (event) {
        if (!window.matchMedia('(min-width: 992px)').matches) return;

        var item = toggle.closest('.site-nav__item');
        var menu = item && item.querySelector(':scope > .site-nav__dropdown');
        if (!item || !menu) return;

        if (!item.classList.contains('bx-menu-open')) {
          event.preventDefault();
          closeMenus(item);
          item.classList.add('bx-menu-open');
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
    });

    document.addEventListener('click', function (event) {
      if (!event.target.closest('.site-nav__item')) closeMenus();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeMenus();
        var activeToggle = document.querySelector('.site-nav [data-bx-menu-toggle]:focus');
        if (activeToggle) activeToggle.blur();
      }
    });
  }

  function initStylistVideo(wrapper) {
    if (wrapper.dataset.bxVideoReady === 'true') return;

    var video = wrapper.querySelector('video');
    var externalVideo = wrapper.querySelector('[data-bx-external-video]');
    if (!video && !externalVideo) return;

    wrapper.dataset.bxVideoReady = 'true';

    function playVideo() {
      if (externalVideo) {
        var provider = externalVideo.dataset.videoProvider;
        var videoId = encodeURIComponent(externalVideo.dataset.videoId || '');
        if (!videoId || (provider !== 'youtube' && provider !== 'vimeo')) return;

        var iframe = document.createElement('iframe');
        var title = externalVideo.dataset.videoTitle || 'Stylist video';

        if (provider === 'youtube') {
          iframe.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&mute=1&loop=1&playlist=' + videoId + '&controls=0&playsinline=1&rel=0';
        } else {
          iframe.src = 'https://player.vimeo.com/video/' + videoId + '?autoplay=1&muted=1&loop=1&background=1&playsinline=1';
        }

        iframe.title = title;
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
        iframe.setAttribute('allowfullscreen', '');
        externalVideo.replaceChildren(iframe);
        wrapper.classList.add('is-video-playing');
        wrapper.setAttribute('aria-pressed', 'true');
        return;
      }

      video.muted = true;
      var playAttempt = video.play();

      if (playAttempt && typeof playAttempt.then === 'function') {
        playAttempt.then(function () {
          wrapper.classList.add('is-video-playing');
          wrapper.setAttribute('aria-pressed', 'true');
        }).catch(function () {
          wrapper.classList.remove('is-video-playing');
          wrapper.setAttribute('aria-pressed', 'false');
        });
      } else {
        wrapper.classList.add('is-video-playing');
        wrapper.setAttribute('aria-pressed', 'true');
      }
    }

    function stopVideo() {
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
      if (externalVideo) externalVideo.replaceChildren();
      wrapper.classList.remove('is-video-playing');
      wrapper.setAttribute('aria-pressed', 'false');
    }

    wrapper.addEventListener('pointerenter', function () {
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) playVideo();
    });

    wrapper.addEventListener('pointerleave', function () {
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) stopVideo();
    });

    wrapper.addEventListener('click', function () {
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      if (wrapper.classList.contains('is-video-playing')) stopVideo();
      else playVideo();
    });

    wrapper.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        if (wrapper.classList.contains('is-video-playing')) stopVideo();
        else playVideo();
      }

      if (event.key === 'Escape') stopVideo();
    });

    wrapper.addEventListener('focusout', function () {
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) stopVideo();
    });
  }

  function init() {
    document.querySelectorAll('[data-bx-match-quiz]').forEach(initMatchQuiz);
    document.querySelectorAll('[data-bx-stylist-video]').forEach(initStylistVideo);
    initCartAccessibility();
    initDesktopNavigation();
    initConversionTracking();
    document.querySelectorAll('[data-section-type="product"]').forEach(initProductGuidance);
    document.querySelectorAll('[data-bx-product-gallery]').forEach(initProductGallery);
    document.querySelectorAll('[data-bx-bundle-savings]').forEach(initBundleSavings);
    restoreMatchPreference();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-bx-stylist-video]').forEach(initStylistVideo);
    event.target.querySelectorAll('[data-section-type="product"]').forEach(initProductGuidance);
    event.target.querySelectorAll('[data-bx-product-gallery]').forEach(initProductGallery);
    event.target.querySelectorAll('[data-bx-bundle-savings]').forEach(initBundleSavings);
  });
})();
